import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.templateFactory', {
    defaultStepName: 'Approval step',
    defaultWorkflowName: 'New workflow',
});
